<template>
  <section id="interactive-map">
    <section id="property-map">
      <div class="container">
        <h1 class="page-heading offset"><span class="off-white-text">{{ hotelsCount }} Hotels<br></span><span class="blue-text">Across Canada.</span></h1>

        <div>
          <div v-if="!allHotels">
            <div class="loader-wrapper">
              <!-- By Sam Herbert (@sherb), for everyone. More @ http://goo.gl/7AJzbL -->
              <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#fff">
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(1 1)" stroke-width="2">
                    <circle stroke-opacity=".5" cx="18" cy="18" r="18" />
                    <path d="M36 18c0-9.94-8.06-18-18-18">
                      <animateTransform attributeName="transform" type="rotate" from="0 18 18" to="360 18 18" dur="1s" repeatCount="indefinite" />
                    </path>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          <div v-else>
            <div ref="map" class="hotel-map">
            </div>

            <div class="map-filter-container">
              <div class="filter-row regions" :class="{ active: activeFilters['regions'].length }">
                <span class="filter-label">Region<span class="reset-filters" @click="resetFilter('regions'); resetFilter('subregions')">&times;</span></span>
                <ul class="filter-list" v-if="filters.regions">
                  <li
                    v-for="(value, key) in filters.regions"
                    @click="toggleFilter('regions', key)"
                    :key="key"
                    :class="{ active: activeFilters['regions'].includes(key), disabled: disabledFilters['regions'].includes(key) }"
                  >
                    <span class="region-parent">{{value.name}}</span>


                    <ul class="subregions" v-if="value['sub-regions']">
                      <li
                        v-for="(label, key) in value['sub-regions']"
                        v-if="value['sub-regions']"
                        @click="toggleFilter('subregions', key)"
                        :key="key"
                        :class="{ active: activeFilters['subregions'].includes(key), disabled: disabledFilters['subregions'].includes(key) }"
                      >
                          {{ label }}
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>

              <div class="filter-row" :class="{ active: activeFilters['services'].length }">
                <span class="filter-label">Service<span class="reset-filters" @click="resetFilter('services')">&times;</span></span>

                <ul class="filter-list" v-if="filters.services">
                  <li
                    v-for="(label, value) in filters.services"
                    @click="toggleFilter('services', value)"
                    :key="value"
                    :class="{ active: activeFilters['services'].includes(value), disabled: disabledFilters['services'].includes(value) }"
                  >
                    {{label}}
                  </li>
                </ul>
              </div>

              <div class="filter-row" :class="{ active: activeFilters['brands'].length }">
                <span class="filter-label">Brand<span class="reset-filters" @click="resetFilter('brands')">&times;</span></span>

                <ul class="filter-list" v-if="filters.brands">
                  <li
                    v-for="(label, value) in filters.brands"
                    @click="toggleFilter('brands', value)"
                    :key="value"
                    :class="{ active: activeFilters['brands'].includes(value), disabled: disabledFilters['brands'].includes(value) }"
                  >
                    {{label}}
                  </li>
                </ul>
              </div>
              <div class="filter-row">
                <span class="filter-label" @click="clearFilters">Clear Filters</span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="property-listings" v-if="allHotels">
      <div id="property-listings-container" class="container">
        <ProvinceListing v-if="filteredHotelsByProvince('Alberta').length" province="Alberta" :hotels="filteredHotelsByProvince('Alberta')" />
        <ProvinceListing v-if="filteredHotelsByProvince('British Columbia').length" province="British Columbia" :hotels="filteredHotelsByProvince('British Columbia')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Manitoba').length" province="Manitoba" :hotels="filteredHotelsByProvince('Manitoba')" />
        <ProvinceListing v-if="filteredHotelsByProvince('New Brunswick').length" province="New Brunswick" :hotels="filteredHotelsByProvince('New Brunswick')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Nova Scotia').length" province="Nova Scotia" :hotels="filteredHotelsByProvince('Nova Scotia')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Ontario').length" province="Ontario" :hotels="filteredHotelsByProvince('Ontario')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Prince Edward Island').length" province="Prince Edward Island" :hotels="filteredHotelsByProvince('Prince Edward Island')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Quebec').length" province="Quebec" :hotels="filteredHotelsByProvince('Quebec')" />
        <ProvinceListing v-if="filteredHotelsByProvince('Saskatchewan').length" province="Saskatchewan" :hotels="filteredHotelsByProvince('Saskatchewan')" />
      </div>
    </section>
  </section>
</template>

<script>
import MarkerClusterer from '@google/markerclustererplus'
import ProvinceListing from "./province-listing"

export default {
  name: "hotel-map",
  data() {
    return {
      map: null,
      markerClusterer: null,
      currentInfoWindow: null,
      filteredHotels: [],
      allHotels: null,
      filters: window.innvest.filters,
      hotelsCount: window.innvest.hotelCount,
      activeFilters: {
        brands: [],
        regions: [],
        subregions: [],
        services: []
      },
      disabledFilters: {
        brands: [],
        regions: [],
        subregions: [],
        services: []
      },
      regionMapping: {
        Alberta: "western",
        "British Columbia": "western",
        Manitoba: "western",
        "New Brunswick": "atlantic",
        Newfoundland: "atlantic",
        "North West Territories": "western",
        "Nova Scotia": "atlantic",
        Nunavut: "western",
        Ontario: "ontario",
        "Prince Edward Island": "atlantic",
        Quebec: "quebec",
        Saskatchewan: "western"
      }
    }
  },
  components: {
    ProvinceListing
  },
  mounted() {
    this.filters.subregions = {}
    Object.keys(this.filters.regions).map((regionKey) => {
      let region = this.filters.regions[regionKey]
      if (region['sub-regions']) {
        this.filters.subregions = Object.assign(this.filters.subregions, region['sub-regions'])
      }
    })

    var request = new XMLHttpRequest()
    request.open(
      "GET",
      "/wp-json/wp/v2/hotels/?status=publish&per_page=100",
      true
    )
    request.onload = () => {
      if (request.status >= 200 && request.status < 400) {
        let responseBody = JSON.parse(request.responseText)

        this.allHotels = _.map(responseBody, hotel => {
          let customFields = hotel.acf
          hotel = _.merge(hotel, hotel.acf)
          hotel.region = this.regionMapping[hotel.hotel_province]
          return hotel
        })

        // Initial hotel load: show all then apply URL
        this.filteredHotels = this.allHotels

        this.$nextTick(() => {
          this.initializeMap()
        })
      } else {
        console.error("OnLoad: Could not fetch hotel data!")
      }
    }
    request.onerror = () =>
      console.error("OnError: Could not fetch hotel data!")
    request.send()
  },
  methods: {
    initializeMap() {
      var mapStyles = [
        {
          featureType: "administrative.land_parcel",
          elementType: "labels",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "landscape",
          elementType: "geometry",
          stylers: [
            {
              color: "#ececf0"
            }
          ]
        },
        {
          featureType: "landscape.man_made",
          elementType: "geometry",
          stylers: [
            {
              color: "#ececf0"
            }
          ]
        },
        {
          featureType: "poi",
          elementType: "labels.text",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "poi.business",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c1ecd0"
            }
          ]
        },
        {
          featureType: "poi.park",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#a3e9cb"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#e3e3f4"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#c5c5e9"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#21364b"
            }
          ]
        },
        {
          featureType: "road.highway",
          elementType: "labels.text.stroke",
          stylers: [
            {
              color: "#e9e9f8"
            },
            {
              weight: 2
            }
          ]
        },
        {
          featureType: "road.highway.controlled_access",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#c0c0e9"
            }
          ]
        },
        {
          featureType: "road.highway.controlled_access",
          elementType: "geometry.stroke",
          stylers: [
            {
              color: "#9c9cda"
            }
          ]
        },
        {
          featureType: "road.local",
          elementType: "labels",
          stylers: [
            {
              visibility: "off"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "geometry.fill",
          stylers: [
            {
              color: "#82ccca"
            }
          ]
        },
        {
          featureType: "water",
          elementType: "labels.text.fill",
          stylers: [
            {
              color: "#00716d"
            }
          ]
        }
      ]

      var styledMap = new google.maps.StyledMapType(mapStyles, {
        name: "Styled Map"
      })

      this.map = new google.maps.Map(this.$refs.map, {
        minZoom: 4,
        maxZoom: 17,
        center: new google.maps.LatLng(43.452969, -80.495064),
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        disableDefaultUI: false
      })

      // bounds of the desired area
      var allowedBounds = new google.maps.LatLngBounds(
        new google.maps.LatLng(21.083219, -152.785877),
        new google.maps.LatLng(71.677051, -36.820976)
      )

      var boundLimits = {
        maxLat: allowedBounds.getNorthEast().lat(),
        maxLng: allowedBounds.getNorthEast().lng(),
        minLat: allowedBounds.getSouthWest().lat(),
        minLng: allowedBounds.getSouthWest().lng()
      }

      var lastValidCenter = this.map.getCenter()
      var newLat, newLng

      google.maps.event.addListener(
        this.map,
        "center_changed",
        function() {
          let center = this.map.getCenter()

          if (allowedBounds.contains(center)) {
            // still within valid bounds, so save the last valid position
            lastValidCenter = this.map.getCenter()
            return
          }

          newLat = lastValidCenter.lat()
          newLng = lastValidCenter.lng()

          if (
            center.lng() > boundLimits.minLng &&
            center.lng() < boundLimits.maxLng
          ) {
            newLng = center.lng()
          }

          if (
            center.lat() > boundLimits.minLat &&
            center.lat() < boundLimits.maxLat
          ) {
            newLat = center.lat()
          }

          this.map.panTo(new google.maps.LatLng(newLat, newLng))
        }.bind(this)
      )

      this.map.mapTypes.set("map_style", styledMap)
      this.map.setMapTypeId("map_style")

      let mcOptions = {
        gridSize: 20,
        maxZoom: 17,
        styles: [
          {
            url: "/wp-content/themes/innvest/img/map/cluster-markers/m5-2.png",
            height: 25,
            width: 25,
            textColor: "#FFFFFF"
          },
          {
            url: "/wp-content/themes/innvest/img/map/cluster-markers/m5-2.png",
            height: 25,
            width: 25,
            textColor: "#FFFFFF"
          },
          {
            url: "/wp-content/themes/innvest/img/map/cluster-markers/m5-2.png",
            height: 25,
            width: 25,
            textColor: "#FFFFFF"
          },
          {
            url: "/wp-content/themes/innvest/img/map/cluster-markers/m5-2.png",
            height: 25,
            width: 25,
            textColor: "#FFFFFF"
          },
          {
            url: "/wp-content/themes/innvest/img/map/cluster-markers/m5-2.png",
            height: 25,
            width: 25,
            textColor: "#FFFFFF"
          }
        ]
      }

      this.markerClusterer = new MarkerClusterer(this.map, [], mcOptions)

      google.maps.event.addListener(this.markerClusterer, 'mouseover', function (cluster) {
        cluster.clusterIcon_.div_.classList.add('cluster-over')
      })

      google.maps.event.addListener(this.markerClusterer, 'mouseout', function (cluster) {
        cluster.clusterIcon_.div_.classList.remove('cluster-over')
      })

      this.showHotels(this.filteredHotels)
      this.applyURLFilters()
    },

    showHotels(hotels) {
      this.resetMapMarkers()
      var labels = ""

      hotels.forEach((hotel, index) => {
        let latlng = new google.maps.LatLng(
          hotel.address.lat,
          hotel.address.lng
        )
        var image = {
          url: "/wp-content/themes/innvest/img/map/marker.png",
          // This marker is 20 pixels wide by 20 pixels high.
          size: new google.maps.Size(20, 20),
          // The origin for this image is (0, 0).
          origin: new google.maps.Point(0, 0),
          // The anchor for this image is the base of the flagpole at (0, 32).
          anchor: new google.maps.Point(10, 10)
        }

        let marker = new google.maps.Marker({
          position: latlng,
          map: this.map,
          icon: image
        })

        google.maps.event.addListener(marker, "click", () => {
          if (this.currentInfoWindow) this.currentInfoWindow.close()

          let infowindow = new SnazzyInfoWindow({
              marker: marker,
              content: this.infowindowForHotel(hotel),
              map: this.map,
              position: latlng
          })

          infowindow.open(this.map, marker)

          this.currentInfoWindow = infowindow
          this.map.setCenter(marker.getPosition())
        })

        this.markerClusterer.addMarker(marker)
      })

      this.disableUnavailableFilters()
      this.centerMap()
    },
    infowindowForHotel(hotel) {
      let address = this.getExpandedAddress(hotel.address.address);
      let boxHTML = `<a href= ${hotel.link}>
                      <span class="si-window-city"
                      <span class="bold-heading">${hotel.title.rendered}</span>
                    </a>`

      if (hotel.hotel_images) {
        boxHTML = `<a href= ${hotel.link}>
                    <div class="si-photo" style="background-image: url(${hotel.hotel_images[0].hotel_image.sizes.large})"></div>
                    <span class="si-city">${address['city']}, ${address['province']}</span>
                    <span class="bold-heading blue-text">${hotel.title.rendered}</span>
                  </a>`
      }
      return boxHTML
    },
    resetMapMarkers() {
      this.markerClusterer.clearMarkers()
    },
    centerMap() {
      var bounds = new google.maps.LatLngBounds()

      let currentMarkers = this.markerClusterer.getMarkers()

      currentMarkers.forEach(marker => {
        var latlng = new google.maps.LatLng(
          marker.position.lat(),
          marker.position.lng()
        )
        bounds.extend(latlng)
      })

      if (currentMarkers.length == 0) {
        this.map.setZoom(4)
      } else if (currentMarkers.length == 1) {
        this.map.setCenter(bounds.getCenter())
        this.map.setZoom(8)
      } else {
        this.map.fitBounds(bounds, 500)
      }
    },
    filterHotels() {
      let results = []

      this.allHotels.forEach(hotel => {
        let brandMatches = true
        let regionMatches = true
        let subregionMatches = true
        let serviceMatches = true

        if (this.activeFilters["brands"].length > 0) {
          brandMatches = this.activeFilters["brands"].includes(
            hotel.hotel_brand
          )
        }

        if (this.activeFilters["regions"].length > 0) {
          regionMatches = this.activeFilters["regions"].includes(hotel.region)
        }

        if (this.activeFilters["subregions"].length > 0) {
          regionMatches = this.activeFilters["subregions"].includes(hotel.hotel_sub_region)
        }

        if (this.activeFilters["services"].length > 0) {
          serviceMatches = this.activeFilters["services"].includes(
            hotel.hotel_service_type
          )
        }

        if (brandMatches && regionMatches && subregionMatches && serviceMatches) {
          results.push(hotel)
        }
      })

      this.filteredHotels = results

      this.showHotels(results)
      this.centerMap()
      this.updateURLFilters()
    },
    updateURLFilters() {
      let filters = this.activeFilters

      let newHash = Object.keys(filters)
        .map(filterName => `${filterName}=${filters[filterName].join(",")}`)
        .join("&")

      window.location.hash = newHash
    },
    applyURLFilters() {
      // Deconstructs a URL filter like:
      // #brands=kimpton,comfort-inn&regions=quebec,ontario
      let hash = window.location.hash.slice(1)

      // Bail out if there are no options
      if (hash.length === 0) return

      let pairs = hash.split("&")
      let options = pairs.map(pair => {
        let kv = pair.split("=")
        let value = kv[1].split(",")
        return { name: kv[0], values: value }
      })

      options.forEach(option => {
        option.values.forEach(value => {
          this.toggleFilter(option.name, value)
        })
      })
    },
    toggleFilter(type, value) {
      if (value === '' || this.disabledFilters[type].includes(value)) {
        return
      }

      if (this.activeFilters[type].includes(value)) {
        // Already on, so remove the option
        let valueIndex = this.activeFilters[type].indexOf(value)
        this.activeFilters[type].splice(valueIndex, 1)
      } else {
        this.activeFilters[type] = this.activeFilters[type].concat([value])
      }

      this.filterHotels()
    },
    disableUnavailableFilters () {
      // loop through filteredHotels
      // get all options, substract options on filteredHotels
      // disable the leftover options that don't match a filteredHotel
      let selectedRegions = _.uniq(this.filteredHotels.map((hotel) => hotel.region))
      this.disabledFilters.regions = _.difference(Object.keys(this.filters.regions), selectedRegions)

      let selectedSubregions = _.uniq(this.filteredHotels.map((hotel) => hotel.hotel_sub_region))
      this.disabledFilters.subregions = _.difference(Object.keys(this.filters.subregions), selectedSubregions)

      let selectedServices = _.uniq(this.filteredHotels.map((hotel) => hotel.hotel_service_type))
      this.disabledFilters.services = _.difference(Object.keys(this.filters.services), selectedServices)

      let selectedBrands = _.uniq(this.filteredHotels.map((hotel) => hotel.hotel_brand))
      this.disabledFilters.brands = _.difference(Object.keys(this.filters.brands), selectedBrands)
    },
    resetFilter(type) {
      this.activeFilters[type] = []
      this.filterHotels()
    },
    clearFilters () {
      this.resetFilter('brands')
      this.resetFilter('services')
      this.resetFilter('regions')
      this.resetFilter('subregions')
    },
    filteredHotelsByProvince(province) {
      let hotels = this.filteredHotels.filter(
        hotel => hotel.hotel_province === province
      )
      return _.sortBy(hotels, hotel => [
        hotel.address.address.split(", ")[1],
        hotel.title.rendered
      ])
    },
    getExpandedAddress(address) {
      let addressParts = [];
      let splitAddress = address.split(', ');
      addressParts['street'] = splitAddress[0];
      addressParts['city'] = splitAddress[1];
      addressParts['province'] = splitAddress[2];
      addressParts['postal'] = splitAddress[3];

      return addressParts;
    }
  }
}
</script>

<style lang="scss">
.loader-wrapper {
  margin: 250px auto;
  color: white;
  text-align: center;
  font-size: 24px;
}

.cluster {
  img {
    height: 100%;
    width: 100%;
  }
}

.cluster-over {
  filter: brightness(95%);
}
</style>



// WEBPACK FOOTER //
// src/hotel-map.vue